import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const comparisonData = [
  { aspect: "Targeting", before: "Zip codes", after: "Specific properties with need" },
  {
    aspect: "Data",
    before: "Static, phone book lists",
    after: "Property-level condition, financial, and behavioral signals",
  },
  {
    aspect: "Effort",
    before: "Boots on the ground, low conversion",
    after: "AI-scored lead lists, ready to action",
  },
  {
    aspect: "Time",
    before: "Years to cover every territory",
    after: "Days or weeks",
  },
  {
    aspect: "Channel",
    before: "Distributors taking orders",
    after: "Distributors converting opportunity",
  },
];

export const BeforeAfterSection = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [tableRef, tableVisible] = useScrollAnimation({ threshold: 0.15 });

  return (
    <section
      className="py-24 px-[5%] border-t border-[#1e1e1e]"
      data-testid="before-after-section"
    >
      <div className="max-w-content mx-auto">
        <div
          ref={headerRef}
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.7s ease-out, transform 0.7s ease-out",
          }}
        >
          <p className="text-[0.7rem] font-semibold tracking-[3px] uppercase text-[#6b7280] mb-6">
            BEFORE / AFTER
          </p>
          <h2 className="text-[clamp(2rem,4vw,3rem)] font-medium tracking-[-0.5px] leading-[1.2] text-white mb-16">
            A new standard for how building products go to market.{" "}
            <span className="text-[#3b82f6]">From broadcast to precision.</span>
          </h2>
        </div>

        {/* Comparison Table */}
        <div 
          ref={tableRef}
          className="border border-[#1e1e1e] rounded-[12px] overflow-x-auto"
          style={{
            opacity: tableVisible ? 1 : 0,
            transform: tableVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.7s ease-out 0.1s, transform 0.7s ease-out 0.1s",
          }}
        >
          <div className="min-w-[320px]">
            {/* Table Header */}
            <div className="grid grid-cols-[25%_37.5%_37.5%] md:grid-cols-[140px_1fr_1fr] bg-[#0a0a0a] border-b border-[#1e1e1e]">
              <div className="p-2 md:p-4 pl-3 md:pl-6">
                <span className="text-[12px] md:text-[0.7rem] font-semibold tracking-[1px] md:tracking-[2px] uppercase text-[#6b7280]">
                  ASPECT
                </span>
              </div>
              <div className="p-2 md:p-4 border-l border-[#1e1e1e]">
                <span className="text-[12px] md:text-[0.7rem] font-semibold tracking-[1px] md:tracking-[2px] uppercase text-[#6b7280] leading-tight block">
                  WITHOUT VERANDA
                </span>
              </div>
              <div className="p-2 md:p-4 border-l border-[#1e1e1e]">
                <span className="text-[12px] md:text-[0.7rem] font-semibold tracking-[1px] md:tracking-[2px] uppercase text-[#3b82f6] leading-tight block">
                  WITH VERANDA
                </span>
              </div>
            </div>

            {/* Table Rows */}
            {comparisonData.map((row, idx) => (
              <div
                key={idx}
                className={`grid grid-cols-[25%_37.5%_37.5%] md:grid-cols-[140px_1fr_1fr] ${
                  idx < comparisonData.length - 1
                    ? "border-b border-[#1e1e1e]"
                    : ""
                }`}
                style={{
                  opacity: tableVisible ? 1 : 0,
                  transform: tableVisible ? "translateX(0)" : "translateX(-20px)",
                  transition: `opacity 0.5s ease-out ${0.2 + idx * 0.08}s, transform 0.5s ease-out ${0.2 + idx * 0.08}s`,
                }}
              >
                <div className="p-2 md:p-5 pl-3 md:pl-6 flex items-center">
                  <span className="text-[14px] md:text-[0.85rem] font-medium text-white">
                    {row.aspect}
                  </span>
                </div>
                <div className="p-2 md:p-5 border-l border-[#1e1e1e] flex items-center gap-2 md:gap-3">
                  <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-[#ef4444] opacity-50 flex-shrink-0"></div>
                  <span className="text-[14px] md:text-[0.85rem] text-[#6b7280]">
                    {row.before}
                  </span>
                </div>
                <div className="p-2 md:p-5 border-l border-[#1e1e1e] flex items-center gap-2 md:gap-3 bg-[rgba(59,130,246,0.03)]">
                  <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-[#10b981] flex-shrink-0"></div>
                  <span className="text-[14px] md:text-[0.85rem] text-white">{row.after}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
